const FORMAT_SUFFIX = /\s+(?:XXS|XS|S|M|L|XL|XXL|XXXL)\s*$/u;

export default function courseTitle(name) {
  return String(name || '').replace(FORMAT_SUFFIX, '').trim();
}
